import RealtimeEditor from '@baidu/realtime-editor';
import {RteInitProps} from '@baidu/realtime-editor/dist/interface';
export type {
    EditorModeType,
    RteMethodProps,
    ReadPluginChangeProps,
    ParticipantUpdater,
    BlockMetaProps,
    ParticipantProps,
} from '@baidu/realtime-editor/dist/interface';

export default RealtimeEditor;

export function getRTEBackUpUrl() {
    if (!process.env.REACT_APP_RTE_WS_PUBLIC) {
        return null;
    }
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${process.env.REACT_APP_RTE_WS_PUBLIC}`;
}

export function getRTEWebsocketUrl() {
    if (!process.env.REACT_APP_RTE_SERVER) {
        return undefined;
    }
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${process.env.REACT_APP_RTE_SERVER}`;
}

type EditorState = RteInitProps['editorState'];
type CommonOptions = RteInitProps['commonOptions'];
type EditorOptions = RteInitProps['editorOptions'];
type PluginOptions = RteInitProps['pluginOptions'];

export type {EditorState, CommonOptions, EditorOptions, PluginOptions};
